export default class Storage {
  static tokenKey = '@auth/token';
  static refreshTokenKey = '@auth/refreshToken';
  static userKey = '@app/user';
  static acceptedTermsAt = '@app/acceptedTermsAt';
  static countryId = '@app/countryId';

  static async getItem(key) {
    const item = localStorage.getItem(key);
    if (item === null || item === 'undefined') {
      return null;
    }
    return JSON.parse(item);
  }

  static async removeItem(key) {
    localStorage.removeItem(key);
  }

  static async setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
